<template>
  <div class="bounty-page">
    <div class="g-container">
      <BountyInfo
        ref="bountyInfoDom"
        class="g-box bounty-page__info"
        @clickSubmit="showSubmitDialog"
      />
      <NouTab class="tab" v-model="selectedTab" :tabs="tabs"></NouTab>
      <SubmitList ref="submitListIns" v-if="selectedTab==='submit'" @login="refreshBounty" />
      <MessageList v-else-if="selectedTab==='message'" @login="refreshBounty" />
      <DeveloperList v-else-if="selectedTab==='developList'" />
    </div>
    <NouDialog
      :visible.sync="submitDialogShowing"
      title=""
      :dialogClass="dialogClass"
    >
      <SubmitForm :submitStatus="submitStatus" @success="handleAddSubmit" @close="submitDialogShowing=false" />
    </NouDialog>
  </div>
</template>

<script>
import BountyInfo from '@/views/Bounty/BountyInfo.vue';
import SubmitList from '@/views/Bounty/SubmitList.vue';
import MessageList from '@/views/Bounty/MessageList.vue';
import SubmitForm from '@/views/Bounty/SubmitForm.vue';
import DeveloperList from '@/views/Bounty/DeveloperList.vue';
import { BOUNTY_STATUS } from '@/config/enum';

export default {
  name: 'BountyPage',
  components: {
    DeveloperList,
    SubmitForm,
    MessageList,
    SubmitList,
    BountyInfo,
  },
  data() {
    return {
      submitDialogShowing: false,
      submitStatus: BOUNTY_STATUS.unsubmitted,
      selectedTab: 'submit',
      tabs: [
        {
          label: this.$t('bounty.submit'),
          value: 'submit',
        },
        {
          label: this.$t('bounty.message'),
          value: 'message',
        },
        {
          label: this.$t('bounty.developList'),
          value: 'developList',
        },
      ],
      dialogClass: {
        'bounty-dialog__dialog': true,
      },
    };
  },
  methods: {
    handleAddSubmit() {
      this.submitDialogShowing = false;
      this.$refs.submitListIns.refresh();
    },
    refreshBounty() {
      this.$refs.bountyInfoDom.fetchBounty();
    },
    showSubmitDialog(submitStatus) {
      this.submitStatus = submitStatus;
      this.submitDialogShowing = true;
    },
  },
  mounted() {
    const dom = document.getElementsByClassName('layout');
    if (dom[0]) {
      dom[0].scrollTop = 0;
    }
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .bounty-page__info {
    margin-top: $padding-sm;
  }

  .tab {
    margin-top: $padding-sm;
    margin-bottom: $padding-sm;
  }

  /deep/ .bounty-dialog__dialog {
    width: 640px;
  }

  .bounty-page {
    padding-bottom: 80px;
  }
</style>
